/**
 * @file Expert dashboard UI — pages/Dashboard/Expert/Submissions/components/NoMaterialState.tsx.
 */

import React from "react";
import AnalysisBanner from "../../../../../components/common/AnalysisBanner";

const NoMaterialState: React.FC = () => {
  return (
    <div className="background-form-container analysis-shell">
      <AnalysisBanner title="Review Submissions" />
      <p className="expert-info-text">Select a material first.</p>
    </div>
  );
};

/** React component — No Material State. */
export default NoMaterialState;

